import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import vuetify from './plugins/vuetify';
import { i18n } from './i18n';
import './registerServiceWorker';
import '@mdi/font/css/materialdesignicons.css';
import '../public/css/fonts.css';
import '../public/css/extra.css';

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  vuetify,
  i18n,
  render: (h) => h(App),
}).$mount('#app');